import { DataProxy } from '@apollo/client'

import { CachedListUpdateStrategy, updateCachedItem, updateCachedList } from '@acre/utils'
import {
  GetProtectionProductsDocument,
  ProtectionProduct,
  RemoveProtectionProductsMutation,
  SaveProtectionProductsMutation,
  UpdateProtectionProductMutation,
} from '@acre/graphql'

export const updateGetProtectionProductCache = async (
  cache: DataProxy,
  data: SaveProtectionProductsMutation | null | undefined,
  caseId: string,
) => {
  const { saveProtectionProducts } = data || {}
  if (!saveProtectionProducts) return

  const variables = { protectionProductDetails: true, filterCaseIds: [caseId] }
  saveProtectionProducts.forEach(async (newProduct) => {
    const payload = {
      readQuery: {
        variables,
        query: GetProtectionProductsDocument,
      },
      writeQuery: {
        variables,
        query: GetProtectionProductsDocument,
      },
      newItem: newProduct,
      strategy: CachedListUpdateStrategy.Prepend,
      key: 'protectionProducts',
    }

    await updateCachedList(cache, payload)
  })
}

export const updateRemoveProtectionProductsCache = async (
  cache: DataProxy,
  data: RemoveProtectionProductsMutation | null | undefined,
  products: ProtectionProduct[],
  caseId: string,
) => {
  const { removeProtectionProducts } = data || {}
  if (!removeProtectionProducts) return

  const remainingProducts = products.filter(({ protection_id }) => !removeProtectionProducts.includes(protection_id!))

  const variables = { protectionProductDetails: true, filterCaseIds: [caseId] }
  const payload = {
    query: GetProtectionProductsDocument,
    variables,
    data: remainingProducts,
    key: 'protectionProducts',
  }

  await updateCachedItem(cache, payload)
}

export const updateProtectionProductCache = async (
  cache: DataProxy,
  data: UpdateProtectionProductMutation | null | undefined,
  products: ProtectionProduct[],
  caseId: string,
) => {
  const { updateProtectionProduct } = data || {}
  if (!updateProtectionProduct) return

  const { protection_id } = updateProtectionProduct
  const idxToReplace = products.findIndex((product) => product.protection_id === protection_id)

  const updatedProducts = [...products]
  updatedProducts.splice(idxToReplace, 1, updateProtectionProduct)

  const variables = { protectionProductDetails: true, filterCaseIds: [caseId] }
  const payload = {
    query: GetProtectionProductsDocument,
    variables,
    data: updatedProducts,
    key: 'protectionProducts',
  }

  await updateCachedItem(cache, payload)
}
